// Module
var code = "<template>\n\t<tree-view nodes.bind=\"structureData\" expand-by-default=\"true\" class=\"tree-view\">\n\t\t<template-content target-name=\"node\">\n\t\t\t<span class=\"title\">${current.title} (${current.id})</span>\n\t\t</template-content>\n\t</tree-view>\n</template>\n";
// Exports
export default code;